import { render, staticRenderFns } from "./SatelliteActivityRegisterShare.vue?vue&type=template&id=3f0a0c5a&scoped=true&"
import script from "./SatelliteActivityRegisterShare.vue?vue&type=script&lang=js&"
export * from "./SatelliteActivityRegisterShare.vue?vue&type=script&lang=js&"
import style0 from "./SatelliteActivityRegisterShare.vue?vue&type=style&index=0&id=3f0a0c5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f0a0c5a",
  null
  
)

export default component.exports